import BaseService from './base';

class LeadService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/lead`;
  }

  save(model) {

    return this.request(`${this.getUrl()}`, model, 'POST')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

}

export default new LeadService();